import { replaceAll } from './stringUtils';

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
      );
    // /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
};

export const validarCpf = (cpf: string): boolean => {
  let soma = 0;
  let resto;
  cpf = cpf.trim();
  cpf = replaceAll(cpf, '.', '');
  cpf = replaceAll(cpf, '-', '');
  cpf = replaceAll(cpf, '_', '');

  if (cpf.length === 0) {
    return false;
  }

  if (cpf.length !== 11) {
    return false;
  }

  //CPF dígitos igual
  var testeDigitosIguais = true;
  for (var i = 0; i < cpf.length - 1; i++) {
    if (cpf[i] !== cpf[i + 1]) {
      testeDigitosIguais = false;
    }
  }
  if (testeDigitosIguais) {
    return false;
  }

  //Calcula e valida o primeiro dígito
  for (i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;

  //Calcula e valida o segundo dígito
  soma = 0;
  for (i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;

  return true;
};
